import {
  ONBOARDING,
  UPDATE_PROFILE,
  GET_PROFILE,
  SAVE_PROFILE,
  ACTIVE_NOTIF_VIEW,
  GET_PROFILE_BY_USER,
  RESET_PROFILE_ACTION,
  RESET_PROFILE
  // EDIT_PROFILE
} from '../actions/profileQueries'
import { userDB } from '../../firestoreDB'
import * as Sentry from '@sentry/vue'
// import { browserLog } from '../../helper/helper'

const getDefaultState = () => ({
  profile: {
    avatar_uri: require('@/assets/img/user-default.png'),
    name: '',
    surname: '',
    disabled_fields: [],
    email: '',
    phone: '',
    onboarding: false,
    active_notification: true,
    has_children: true,
    children_birthdate: []
  }
})

const state = getDefaultState()

const getters = {
  getProfileData: state => {
    return state.profile
  }
}

const actions = {
  [ONBOARDING]: ({ commit, getters }, userUpdates) => {
    return new Promise((resolve, reject) => {
      userDB
        .doc(getters.firebaseUUID())
        .update(userUpdates)
        .then(() => {
          commit(UPDATE_PROFILE, userUpdates)
        })
      resolve(true)
    })
  },
  [ACTIVE_NOTIF_VIEW]: ({ commit, getters }, isAcceptNotif) => {
    return new Promise((resolve, reject) => {
      userDB
        .doc(getters.firebaseUUID())
        .update({active_notification: isAcceptNotif})
        .then(() => {
          commit(UPDATE_PROFILE, {active_notification: isAcceptNotif})
        })
      resolve(true)
    })
  },
  [GET_PROFILE_BY_USER]: ({ commit, getters }, userId) => {
    return new Promise((resolve, reject) => {
      userDB.doc(userId).onSnapshot(
        { includeMetadataChanges: true },
        documentSnapshot => {
          if (documentSnapshot.exists) {
            const userData = documentSnapshot.data()
            commit(SAVE_PROFILE, userData)
            resolve(userData)
          }
        },
        error => {
          Sentry.captureException(error.message)
          reject(error.message)
        }
      )
    })
  },
  [GET_PROFILE]: ({ commit, getters }) => {
    return new Promise((resolve, reject) => {
      userDB.doc(getters.firebaseUUID()).onSnapshot(
        { includeMetadataChanges: true },
        documentSnapshot => {
          if (documentSnapshot.exists) {
            const userData = documentSnapshot.data()
            commit(SAVE_PROFILE, userData)
            resolve(userData)
          }
        },
        error => {
          Sentry.captureException(error.message)
          reject(error.message)
        }
      )
    })
  },
  [RESET_PROFILE_ACTION]: ({commit}) => {
    commit(RESET_PROFILE)
  }
}

const mutations = {
  [SAVE_PROFILE]: (state, user) => {
    state.profile = { ...state.profile, ...user }
  },
  [UPDATE_PROFILE]: (state, userChanges) => {
    state.profile = {
      ...state.profile,
      ...userChanges
    }
  },
  [RESET_PROFILE]: (state) => {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profileQuery.js